module.exports = __webpack_public_path__ + "img/NCASH.438f1846.svg";